// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__pI7SP","myModalContent":"MyModal_myModalContent__W23op","active":"MyModal_active__fFipl"};